export default __webpack_public_path__ + "static/media/boutiquemate.58a5a68c.png";